import React from "react";
import MainContainer from "../components/common/Container";
import { skillsData } from "../utils/data";
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
const Skills = () => {
  const theme = useTheme();
  return (
    <MainContainer header="SKILLS">
      <Stack gap="10px">
        {skillsData.map((skill) => (
          <Card
            sx={{
              // minWidth: 275,
              position: "relative",
              paddingX: "20px",
              paddingY: "5px",
              "&:hover .decoration ": {
                width: "100%",
                height: "100%",
                position: "absolute",
                left: "0",
                top: "0",
              },
              "&:hover .buttonSkill ": {
                color:"white",
                // 
              },
            }}
          >
            <Button sx={{color:"inherit",zIndex:100}}  className="buttonSkill">{skill.name}</Button>

            <Box
              className="decoration"
              sx={{
                width: skill.width,
                height: "100%",
                backgroundColor: theme.palette.primary.main,
                position: "absolute",
                left: 0,
                top: 0,
                transition: ".8s",
              }}
            />
          </Card>
        ))}
      </Stack>
    </MainContainer>
  );
};

export default Skills;
